export const Data = [
    {   title:"モデルオフィス01",
        img:"./assets/o-1.png"
    },
    {   title:"モデルオフィス02",
        img:"./assets/o-2.png"
    },
    {   title:"モデルオフィス03",
        img:"./assets/o-3.png"
    },
    {   title:"モデルエントランス01",
        img:"./assets/e-1.png"
    },
    {   title:"モデルエントランス02",
        img:"./assets/e-2.png"
    },
    {   title:"モデルエントランス03",
        img:"./assets/e-3.png"
    },
    

    {   title:"モデルフリーエリア01",
        img:"./assets/f-1.png"
    },
    {   title:"モデルフリーエリア02",
        img:"./assets/f-2.png"
    },
    {   title:"モデルフリーエリア03",
        img:"./assets/f-3.png"
    },
    {   title:"モデルフリーエリア04",
        img:"./assets/f-4.png"
    },
    {   title:"モデルフリーエリア05",
        img:"./assets/f-5.png"
    },
    {   title:"モデルフリーエリア06",
        img:"./assets/f-6.png"
    },


    {   title:"バーカウンター-1",
        img:"./assets/03.png"
    },
    {   title:"エントランス-1",
        img:"./assets/02.png"
    },
    {   title:"エントランス-2",
        img:"./assets/13.png"
    },
    {   title:"エントランス-3",
        img:"./assets/16.png"
    },
    {   title:"エントランス-4",
        img:"./assets/25.png"
    },
    {   title:"オフィス受付-1",
        img:"./assets/04.png"
    },
    {   title:"ワークルーム-1",
        img:"./assets/05.png"
    },
    {   title:"ラックルーム-1",
        img:"./assets/06.png"
    },
    {   title:"ﾊﾟｰﾃｨｼｮﾝﾙｰﾑ-1",
        img:"./assets/08.png"
    },
    {   title:"オフィス-1",
        img:"./assets/09.png"
    },
    {   title:"オフィス-2",
        img:"./assets/18.png"
    },
    {   title:"オフィス-3",
        img:"./assets/23.png"
    },
    {   title:"オフィス-4",
        img:"./assets/30.png"
    },
    {   title:"オフィス-5",
        img:"./assets/31.png"
    },
    {   title:"オフィス-6",
        img:"./assets/44.png"
    },
    {   title:"オフィス-7",
        img:"./assets/33.png"
    },
    {   title:"オフィス-8",
    img:"./assets/38.png"
    },

    {   title:"大会議室-1",
        img:"./assets/01.png"
    },
    {   title:"大会議室-2",
        img:"./assets/12.png"
    },
    {   title:"大会議室-3",
        img:"./assets/15.png"
    },
    {   title:"大会議室-4",
        img:"./assets/32.png"
    },

    {   title:"小会議室-1",
        img:"./assets/10.png"
    },
    {   title:"小会議室-2",
        img:"./assets/11.png"
    },
    {   title:"小会議室-3",
        img:"./assets/21.png"
    },
    {   title:"小会議室-4",
        img:"./assets/24.png"
    },
    {   title:"小会議室-5",
        img:"./assets/45.png"
    },
    {   title:"小会議室-6",
        img:"./assets/34.png"
    },

    {   title:"研修室-1",
        img:"./assets/19.png"
    },
    {   title:"研修室-2",
        img:"./assets/22.png"
    },
    {   title:"研修室-3",
        img:"./assets/35.png"
    },

    {   title:"診療所-1",
        img:"./assets/26.png"
    },
    {   title:"診察室-1",
    img:"./assets/29.png"
    },
    {   title:"パーソナルジム",
    img:"./assets/36.png"
    },
    {   title:"展示会-1",
    img:"./assets/37.png"
    },

    

    

    {   title:"ﾆｺﾆｺ超会議2023-1",
    img:"./assets/v1.png"
    },
    {   title:"ﾆｺﾆｺ超会議2023-2",
    img:"./assets/v2.png"
    },
     {   title:"ﾆｺﾆｺ超会議2023-3",
    img:"./assets/v3.png"
    },


    {   title:"POPUPストア",
    img:"./assets/vr11.png"
    },


    {   title:"神奈川某所1",
    img:"./assets/39.png"
    },
    {   title:"神奈川某所2",
    img:"./assets/40.png"
    },
 
    

    {   title:"保土谷某所1",
    img:"./assets/41.png"
    },
    {   title:"保土谷某所2",
    img:"./assets/42.png"
    },
    {   title:"保土谷某所3",
    img:"./assets/43.png"
    },

    {   title:"桜木町某所1",
    img:"./assets/44.png"
    },
    {   title:"桜木町某所2",
    img:"./assets/45.png"
    },

    {   title:"蛎殻町某所1",
    img:"./assets/46.png"
    },

    {   title:"杉並堀ノ内職場",
    img:"./assets/47.png"
    },

    {   title:"杉並堀ノ内水回り",
    img:"./assets/48.png"
    },

    {   title:"杉並堀ノ内個室",
    img:"./assets/49.png"
    },

    {   title:"日本橋某所",
    img:"./assets/50.png"
    },

    {   title:"蛎殻町某所2",
    img:"./assets/51.png"
    },

    {   title:"新川某所1",
    img:"./assets/52.png"
    },
    {   title:"新川某所2",
    img:"./assets/53.png"
    },
    {   title:"新川某所3",
    img:"./assets/54.png"
    },
    {   title:"新川某所4",
    img:"./assets/55.png"
    },
    {   title:"新川某所5",
    img:"./assets/56.png"
    },
    {   title:"横須賀某所1",
    img:"./assets/57.png"
    },
    {   title:"横須賀某所2",
    img:"./assets/58.png"
    },
    {   title:"根岸某所1",
    img:"./assets/59.png"
    },
    {   title:"根岸某所2",
    img:"./assets/60.png"
    },
    {   title:"こうなん某所",
    img:"./assets/61.png"
    },
    {   title:"磯子某所1",
    img:"./assets/62.png"
    },
    {   title:"磯子某所2",
    img:"./assets/63.png"
    },
    {   title:"港北某所",
    img:"./assets/64.png"
    },
    {   title:"由比ヶ浜某所1",
        img:"./assets/65.png"
    },
    {   title:"由比ヶ浜某所2",
        img:"./assets/66.png"
    },
    {   title:"瀬谷某所1",
        img:"./assets/67.png"
    },
    {   title:"綱島某所1",
        img:"./assets/68.png"
    },



    




];